"use strict";
/*
 * PHPConfig - Loads Uniter's PHP configuration
 * Copyright (c) Dan Phillimore (asmblah)
 * https://github.com/uniter/phpconfig/
 *
 * Released under the MIT license
 * https://github.com/uniter/phpconfig/raw/master/MIT-LICENSE.txt
 */
Object.defineProperty(exports, "__esModule", { value: true });
var path_1 = require("path");
/**
 * @inheritDoc
 */
var Loader = /** @class */ (function () {
    function Loader(existsSync, requirer, fileName) {
        this.existsSync = existsSync;
        this.requirer = requirer;
        this.fileName = fileName;
    }
    /**
     * @inheritDoc
     */
    Loader.prototype.load = function (searchDirectories) {
        for (var _i = 0, searchDirectories_1 = searchDirectories; _i < searchDirectories_1.length; _i++) {
            var searchDirectory = searchDirectories_1[_i];
            var searchPath = path_1.join(searchDirectory, this.fileName);
            if (this.existsSync(searchPath)) {
                return this.requirer.require(searchPath);
            }
        }
        return {};
    };
    return Loader;
}());
exports.default = Loader;
//# sourceMappingURL=Loader.js.map